// extracted by mini-css-extract-plugin
export var icon = "_6x-1";
export var subtext = "_6x-0";